import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card} from 'material-ui/Card';
import compose from 'recompose/compose';
import inflection from 'inflection';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import PageDescription from '../components/PageDescription';
import {crudGetOne as crudGetOneAction} from '../admin/dataActionsWithType';
import DefaultActions from 'admin-on-rest/lib/mui/detail/ShowActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

export class ShowWithType extends Component {

    componentDidMount() {
        this.updateData();
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.id !== nextProps.id ||
            this.props.type !== nextProps.type ||
            nextProps.version !== this.props.version
        ) {
            this.updateData(nextProps.resource, nextProps.type, nextProps.id);
        }
    }

    getBasePath() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -2)
            .join('/');
    }

    updateData(resource = this.props.resource, type = this.props.type, id = this.props.id) {
        this.props.crudGetOne(resource, type, id, this.getBasePath());
    }

    render() {
        const {
            actions = <DefaultActions/>,
            title,
            children,
            type,
            id,
            data,
            desc,
            isLoading,
            resource,
            hasList,
            hasDelete,
            hasEdit,
            translate,
            version,
        } = this.props;

        if (!children) return null;
        const basePath = this.getBasePath();

        const resourceName = translate(`resources.${resource}.name`, {
            smart_count: 1,
            _: inflection.humanize(inflection.singularize(resource)),
        });
        const defaultTitle = translate('aor.page.show', {
            name: `${resourceName}`,
            type,
            id,
            data,
        });
        const titleElement = data ? (
            <Title title={title} record={data} defaultTitle={defaultTitle}/>
        ) : (
            ''
        );
        const descriptionElement = data ? (
            <PageDescription record={data} desc={desc}/>
        ) : (
            ''
        );

        return (
            <div>
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    {actions &&
                    React.cloneElement(actions, {
                        basePath,
                        data,
                        hasList,
                        hasDelete,
                        hasEdit,
                        resource,
                    })}
                    <ViewTitle title={titleElement}/>
                    {descriptionElement}
                    {data &&
                    React.cloneElement(children, {
                        resource,
                        basePath,
                        record: data,
                        translate,
                        version,
                    })}
                </Card>
            </div>
        );
    }
}

ShowWithType.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    crudGetOne: PropTypes.func.isRequired,
    data: PropTypes.object,
    desc: PropTypes.any,
    hasList: PropTypes.bool,
    hasDelete: PropTypes.bool,
    hasEdit: PropTypes.bool,
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func,
    version: PropTypes.number.isRequired,
};

function mapStateToProps(state, props) {
    return {
        type: decodeURIComponent(props.match.params.type),
        id: decodeURIComponent(props.match.params.id),
        data: state.admin.resources[props.resource]
            ? state.admin.resources[props.resource].data[
                decodeURIComponent(props.match.params.id)
                ]
            : null,
        isLoading: state.admin.loading > 0,
        version: state.admin.ui.viewVersion,
    };
}

const enhance = compose(
    connect(mapStateToProps, {crudGetOne: crudGetOneAction}),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(ShowWithType);


// WEBPACK FOOTER //
// ./src/Fuse/admin/ShowWithType.js